(function () {
  function initFaq(root) {
    root.querySelectorAll('[data-fw-faq-item]').forEach(function (item) {
      var button = item.querySelector('[data-fw-faq-toggle]');
      var panel = item.querySelector('[data-fw-faq-panel]');
      if (!button || !panel || button.dataset.fwFaqBound === 'true') return;
      button.dataset.fwFaqBound = 'true';

      button.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-fw-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!(section instanceof Element)) return;
    section.querySelectorAll('[data-fw-faq]').forEach(initFaq);
  });
})();
